import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Latin from "./ShadowsIntoLight-Regular-UqyNK9UOIntux_czAvDQx_ZcHqZXBNQze8D55TecYeIo.woff2";

export const ShadowsIntoLightFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
